import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  id: "features",
  class: "container mx-auto py-24 sm:py-32"
}
const _hoisted_2 = { class: "grid sm:grid-cols-2 lg:grid-cols-3 gap-4" }
const _hoisted_3 = { class: "bg-[#ff9500]/20 p-2 rounded-full ring-8 ring-[#ff9500]/10 mb-4" }

import { Card, CardContent, CardHeader, CardTitle } from "@/components/landingPage/ui/card";

import {
  Paintbrush,
  MessageCircle,
  TabletSmartphone,
  BadgeCheck,
  Goal,
  PictureInPicture,
  MousePointerClick,
  Newspaper,
} from "lucide-vue-next";

interface FeaturesProps {
  icon: string;
  title: string;
  description: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Features',
  setup(__props) {

const featureList: FeaturesProps[] = [
  {
    icon: "tabletSmartphone",
    title: "Profil personnalisé",
    description:
      "Créez votre profil unique basé sur vos intérêts, compétences et préférences professionnelles à travers des activités ludiques.",
  },
  {
    icon: "badgeCheck",
    title: "Mini-jeux d'évaluation",
    description:
      "Découvrez vos forces à travers des jeux : scénarios, suites logiques, métiers, vitesse, compétences et environnement de travail.",
  },
  {
    icon: "goal",
    title: "Matching intelligent",
    description:
      "Algorithme IA pour recommander des emplois, formations et entreprises selon vos compétences et préférences.",
  },
  {
    icon: "pictureInPicture",
    title: "Interface gamifiée",
    description:
      "Progression motivante avec badges, quêtes et niveaux. Design adapté aux besoins sensoriels TSA pour réduire l'anxiété.",
  },
  {
    icon: "mousePointerClick",
    title: "Tableau de bord",
    description:
      "Visualisez vos progrès, objectifs et activités. Accédez à des ressources pédagogiques adaptées à votre rythme.",
  },
  {
    icon: "newspaper",
    title: "Sécurité RGPD",
    description:
      "Données chiffrées et hébergement sécurisé. Vous gardez le contrôle total sur vos informations partagées.",
  },
];

const iconMap: Record<
  string,
  | typeof TabletSmartphone
  | typeof BadgeCheck
  | typeof Goal
  | typeof PictureInPicture
  | typeof Paintbrush
  | typeof MousePointerClick
  | typeof MessageCircle
  | typeof Newspaper
> = {
  tabletSmartphone: TabletSmartphone,
  badgeCheck: BadgeCheck,
  goal: Goal,
  pictureInPicture: PictureInPicture,
  paintbrush: Paintbrush,
  mousePointerClick: MousePointerClick,
  messageCircle: MessageCircle,
  newspaper: Newspaper,
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "text-lg text-[#ff9500] text-center mb-2 tracking-wider" }, " Fonctionnalités ", -1)),
    _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "text-3xl md:text-4xl text-center font-bold mb-4" }, " Une plateforme complète et bienveillante ", -1)),
    _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "md:w-1/2 mx-auto text-xl text-center text-muted-foreground mb-8" }, " La plateforme repose sur la collecte, visualisation et analyse des données issues des parcours et jeux pour créer un profil unique et évolutif. ", -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(featureList, ({ icon, title, description }) => {
        return _createElementVNode("div", { key: title }, [
          _createVNode(_unref(Card), { class: "h-full bg-background border-0 shadow-none" }, {
            default: _withCtx(() => [
              _createVNode(_unref(CardHeader), { class: "flex justify-center items-center" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(iconMap[icon]), { class: "size-6 text-[#ff9500]" }))
                  ]),
                  _createVNode(_unref(CardTitle), null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(title), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024),
              _createVNode(_unref(CardContent), { class: "text-muted-foreground text-center" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(description), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        ])
      }), 64))
    ])
  ]))
}
}

})